import React from 'react';
import { Stack, Typography } from '@mui/material';
import MusicNoteOutlinedIcon from '@mui/icons-material/MusicNoteOutlined';
import { Trans } from 'react-i18next';

export interface UserBandAffiliationLineProps {
  bandName: string;
}

const UserBandAffiliationLine: React.FC<UserBandAffiliationLineProps> = ({ bandName }) => {
  const trimmed = bandName.trim();
  if (!trimmed) return null;

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" useFlexGap sx={{ mt: 0.15 }}>
      <MusicNoteOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary', flexShrink: 0 }} />
      <Typography variant="caption" color="text.secondary" component="span" noWrap>
        <Trans
          i18nKey="common.userBandAffiliation"
          defaults="Plays in <bandName>{{name}}</bandName>"
          values={{ name: trimmed }}
          components={{
            bandName: (
              <Typography
                component="span"
                variant="caption"
                color="text.secondary"
                fontWeight={600}
              />
            ),
          }}
        />
      </Typography>
    </Stack>
  );
};

export default UserBandAffiliationLine;
